'use client';

import Link from 'next/link';

import ChevronLeftIcon from '@flipster/react/icon/generated/ChevronLeftIcon';
import { hstack } from '@flipster/styled-system/patterns';

import { hideIfWebview } from '@web/components/HideIfWebview';

interface Props {
  href: string;
  page: string;
}

const BackButton = ({ href, page }: Props) => {
  return (
    <Link
      href={href}
      replace
      className={hstack({
        display: 'inline-flex',
        textStyle: 'Title/XS',
        color: 'content.default.level-5',
        gap: 4,
        mb: 24,
      })}
    >
      <ChevronLeftIcon size={16} />
      {page}
    </Link>
  );
};

export default hideIfWebview(BackButton);
